module.exports = __webpack_public_path__ + "static/img/bkg-com.f790b24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/syscom/bkg-com.png
// module id = qc7a
// module chunks = 0